import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EquipmentService } from '../../../Services/equipment.service';
import { Equipment } from '../../../Models/equipment.model';

@Component({
  selector: 'app-equipment-form',
  templateUrl: './equipment-form.component.html',
  styleUrls: ['./equipment-form.component.css']
})
export class EquipmentFormComponent {
  equipment: Partial<Equipment> & { customerId: number };
  isEdit: boolean;
  saving = false;

  constructor(
    public dialogRef: MatDialogRef<EquipmentFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private equipmentService: EquipmentService
  ) {
    this.isEdit = !!data?.id;
    this.equipment = {
      id: data?.id,
      name: data?.name ?? '',
      location: data?.location ?? '',
      customerId: data?.customerId
    };
  }

  save(): void {
    if (!this.equipment.name?.trim()) return;
    this.saving = true;

    const payload = {
      name: this.equipment.name,
      location: this.equipment.location,
      customerId: this.equipment.customerId
    };

    if (this.isEdit) {
      this.equipmentService.updateEquipment(this.equipment.id!, payload as Equipment).subscribe({
        next: () => { this.saving = false; this.dialogRef.close(true); },
        error: () => { this.saving = false; }
      });
    } else {
      this.equipmentService.createEquipment(payload).subscribe({
        next: () => { this.saving = false; this.dialogRef.close(true); },
        error: () => { this.saving = false; }
      });
    }
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
